// Pass a boolean to this action
export const foundGame = (value) => ({ type: 'SET_FOUND_GAME', value });
